import styles from './index.module.scss';
import cx from 'classnames';

interface EllipsisText {
  text: string;
  lineClamp?: number;
  ellipsisWrapperClass?: string;
}

const EllipsisText = (props: EllipsisText) => {
  const { lineClamp = 1, text, ellipsisWrapperClass } = props;
  return (
    <span
      style={{
        WebkitLineClamp: lineClamp
      }}
      className={cx(styles.handleEllipsis, ellipsisWrapperClass)}
    >
      {text}
    </span>
  );
};

export default EllipsisText;
